<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-26 10:50:05
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-11-03 16:16:13
 * @FilePath: /designcenter/src/layout/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app-wrapper">
    <!-- 顶部导航 -->
    <Navbar />
    <div class="main-container" v-if="route.meta?.layout !== 'manual'">
      <!-- 左侧菜单 -->
      <Sidebar class="sidebar-container" v-if="!['TemplateConfig'].includes(route.name)" />
      <!-- 主要内容区域 -->
      <div class="app-main">
        <router-view />
      </div>
    </div>
    <!-- 操作手册布局 -->
    <router-view v-else />
  </div>
  <AddProjectPopup />
  <SelectTemplate />
  <ExportProjectPopup />
  <SelectProject />
</template>

<script setup>
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar.vue'
import AddProjectPopup from '@/components/AddProjectPopup/AddProjectPopup.vue'
import SelectTemplate from '@/components/SelectTemplate/SelectTemplate.vue'
import ExportProjectPopup from '@/components/ExportProjectPopup/ExportProjectPopup.vue'
import SelectProject from '@/components/SelectProject/SelectProject.vue'
import { onMounted, onUnmounted } from 'vue'
import { useLayoutStore } from '@/store/layout'
import { useRoute } from 'vue-router'
const layoutStore = useLayoutStore()

const route = useRoute()
// 设置CSS变量
const setAppMainVars = () => {
  const appMain = document.querySelector('.app-main')
  if (appMain) {
    const rect = appMain.getBoundingClientRect()
    document.documentElement.style.setProperty('--app-main-height', `${rect.height}px`)
    document.documentElement.style.setProperty('--app-main-top', `${rect.top}px`)
  }
}

// 监听窗口大小变化
const handleResize = () => {
  setAppMainVars()
}

onMounted(() => {
  setAppMainVars()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  .main-container {
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    .app-main {
      flex: 1 1 auto;
      height: 100%;
      overflow: hidden;
      background: #fafafa;
    }
  }
}
</style>
